import React, {useState} from 'react';
import s from "../usersTab.module.scss";
import MuiTooltip from "../../../../../../../components/UiKit/MuiTooltip/MuiTooltip";
import SvgSelector from "../../../../../../../components/SvgSelector/SvgSelector";
import {useTranslation} from "react-i18next";
import ConfirmPopup from "../../../../../../../components/UiKit/Popups/ConfirmPopup/ConfirmPopup";
import {useSelector} from "react-redux";
import {teamsSelector} from "../../../../../../../redux/slices/teamsSlice";
import {OWNER, snackbar_warning, TEAM_LEAD} from "../../../../../../../utils/vars/staticVariables";
import useCustomSnackbar from "../../../../../../../hooks/useCustomSnackbar";
import {user_role} from "../../../../../../../storage/user";
import {subscriptionSelector} from "../../../../../../../redux/slices/subscriptionSlice";

const UserTr = ({
                    username,
                    email,
                    id,
                    team_name,
                    role,
                    is_active,
                    subscription_service_id,
                    is_email_verified,
                    onSwitchUserStatusHandler,
                    onRemoveUserHandler
                }) => {
    const [isActiveSwitchUserStatusPopup, setActiveSwitchUserStatusPopup] = useState(false);
    const [isActiveRemoveUserPopup, setActiveRemoveUserPopup] = useState(false);

    const {t} = useTranslation();

    const {switchUserStatusPending, removeUserFromTeamPending} = useSelector(teamsSelector)
    const {setCanTmAddCount} = useSelector(subscriptionSelector)

    const showSnackbar = useCustomSnackbar();

    return (
        <tr>
            <td>{username}</td>
            <td>{email}</td>
            <td>{team_name}</td>
            <td>{t(role)}</td>
            <td
                className={`
                ${s.statusUserTd}
                ${!is_email_verified ? s.notVerified : ''}
                ${is_email_verified && is_active ? s.active : ''}
                ${is_email_verified && !is_active ? s.archived : ''}
                `}
            >
                {
                    !is_email_verified && t('awaiting_activation')
                }
                {
                    is_email_verified && t(is_active ? 'active' : 'archived')
                }
            </td>

            <td className={s.actionsTd}>
                <ConfirmPopup
                    icon={<SvgSelector id="popup-remove-icon"/>}
                    active={isActiveRemoveUserPopup}
                    setActive={setActiveRemoveUserPopup}
                    action={() => onRemoveUserHandler(subscription_service_id)}
                    confirmBtnText={t("button_remove")}
                    title={t("user_removing")}
                    description={
                        <>
                            {t("want_to_remove")}{" "}
                            <span
                                style={{
                                    color: "#fff",
                                    fontWeight: 500,
                                    marginLeft: 5,
                                    marginRight: 5,
                                }}
                            >
                              {username}
                            </span>
                            ?
                        </>
                    }
                    subDescription1={t('user_data_link_to_your_account')}
                />
                <ConfirmPopup
                    icon={<SvgSelector id={!is_active ? 'team-activate-user-icon' : 'team-archive-user-icon'}/>}
                    active={isActiveSwitchUserStatusPopup}
                    setActive={setActiveSwitchUserStatusPopup}
                    action={() => onSwitchUserStatusHandler(subscription_service_id, is_active)}
                    confirmBtnText={t(is_active ? "archive" : "activate_button")}
                    title={t(is_active ? "user_archiving" : "user_activation")}
                    description={
                        <>
                            {t(is_active ? "want_to_archive" : 'want_to_activate')}{" "}
                            <span
                                style={{
                                    color: "#fff",
                                    fontWeight: 500,
                                    marginLeft: 5,
                                    marginRight: 5,
                                }}
                            >
                              {username}
                            </span>
                            ?
                        </>
                    }
                />
                {
                    is_email_verified && <div className={s.actionsWrapper}>
                        {
                            (
                                !(user_role === TEAM_LEAD && role === TEAM_LEAD) ||
                                (user_role === OWNER && is_email_verified && !is_active)
                            ) && (
                                <div className={s.actionsContainer}>
                                    <div className={s.actions}>
                                        {

                                            !(user_role === TEAM_LEAD && role === TEAM_LEAD)
                                                ? <button
                                                    className={s.removeBtn}
                                                    onClick={() => {
                                                        if (user_role === TEAM_LEAD && role === TEAM_LEAD) {
                                                            return showSnackbar(t('cannot_remove_team_lead'), snackbar_warning);
                                                        }
                                                        setActiveSwitchUserStatusPopup(true)
                                                    }}
                                                    disabled={switchUserStatusPending}
                                                >
                                                    <MuiTooltip title={t(is_active ? 'archive' : "activate")}>
                                                        <SvgSelector
                                                            id={is_active ? "team-archive-user-icon" : 'team-activate-user-icon'}/>
                                                    </MuiTooltip>
                                                </button>
                                                : null
                                        }

                                        {
                                            user_role === OWNER
                                            && is_email_verified
                                            && !is_active
                                            && <button
                                                className={s.removeBtn}
                                                onClick={() => setActiveRemoveUserPopup(true)}
                                                disabled={removeUserFromTeamPending}
                                            >
                                                <MuiTooltip title={t("button_remove")}>
                                                    <SvgSelector id="new-remove-icon"/>
                                                </MuiTooltip>
                                            </button>
                                        }
                                    </div>
                                </div>
                            )
                        }
                    </div>
                }
            </td>
        </tr>
    )
}

export default UserTr;